export const TerminalMgmtApi = "getTerminalDisplay";
export const TerminalDataTableListMgmtApi = "getTerminalRHSViewList";
export const TerminalLocationDataTableViewApi = "getTerminalLocationDataTableViewList";
export const Last24HourTransApi = "getTerminalDetailsByLast24Hrs";
export const getBankingSplitAccountInfoApi = "getBankingSplitAccountInfo";
export const getBankingSettlementAccountInfoApi = "getBankingSettlementAccountInfo";
export const getBankingSettlementAccountforEditApi = "getBankingSettlementAccountInfo";
export const getTerminalSurchargeInfoServiceApi = "getTerminalSurchargeInfoService"
export const getTerminalCassettesInfoApi = "getTerminalCassettesInfo"
export const getTerminalManagementActivityInfoApi = "getTerminalManagementActivityInfo"
export const getRegionsDetailsApi = "getRegionDetailsInfo";
export const getRegionsDetailsByIdApi = "getRegionDetailsInfoById"
export const getTerminalErrorInfoApi = "getTerminalErrorInfo"
export const getTerminalLocationByIDApi = "getTerminalLocationByUserId"
export const getUserViewListApi = "getUserViewListForTerminalList"
export const getTerminalBatchInfoApi= "getTerminalBatchInfo";
export const getTerminalTxnHistory ="getTerminalDetailsByTxnHistory"
export const getTerminalDetailByIDForEditApi="getTerminalDetailsByIDForEdit"
export const getTerminalNotesByIDApi ="getTerminalNotesByID"
export const getTerminalSettlementByIDApi="getTerminalSettlementAccountByID"
export const getTerminalSurchargeByIDApi="getTerminalSurchargeAccountByID"
export const getPrintTerminalDetailsByIDApi = "getPrintTerminalDetailsByID"
//edit terminal (orchestrated save — maps to TerminalController.saveTerminalEditFromPortal)
export const saveTerminalEditFromPortalApi = "saveTerminalEditFromPortal"

// for the view settings
export const getUserViewAllSettingsTerminalApi ="getUserViewAllSettingsTerminalApi"
export const getDefaultUserViewAllSettingsTerminalApi ="getUserDefaultViewSettingsTerminalApi"
export const getviewSettingsTerminalLHSApi ="viewSettingsColumnsForTerminalLHS"
export const getViewSettingsTerminalRHSApi ="viewSettingsColumnsForTerminalRHS"
export const getAllColumnsForOptionOnViewSettingsApi ="viewSettingsAllColumnsForTerminal"
export const getTerminalContactDetailsByIDApi="getTerminalContactDetailsByID"
export const getAccountManagerDatatableDetailsApi="getAccountManagerDatatableDetails"
export const getAccountUserListApi = "getAccountOwnerDetails"
export const uploadCryptogramFileApi = "uploadCryptogram"
//for Keymanagement
//accountManager
export const validateAccountManagerExistsApi = "validateAccountManagerExists"
export const isRTAExistsApi ="validateAccountManagerRTA"
export const saveAccountManagerApi = "saveAccountManagerDetails"
export const editAccountManagerApi = "editAccountManagerDetails"
//Override
export const saveAccountManagerScheduleOverrideApi = "saveAccountManagerScheduleOverride"
export const getAccountManagerScheduleOverrideInfoByLoggedUserApi = "getAccountManagerOverrideInfoByLoggedUser"
export const getAccountManagerScheduleOverrideInfoByTerminalIDApi = "getAccountManagerOverrideInfoByTerminalID"
export const removeAccountManagerScheduleOverrideInfoByTerminalIDApi = "removeAccountManagerScheduleOverrideInfoByTerminalID"
//Notes
export const saveAccountManagerNotesApi = "saveAccountManagerNotes"
export const getAccountManagerNotesInfoByLoggedUserApi = "getAccountManagerNotesInfoByLoggedUser"
export const getAccountManagerNotesByNotesIDApi = "getAccountManagerNotesByNotesID"
export const removeAccountManagerNotesByIDApi = "deleteAccountManagerNotesByID"
//master key binding
export const checkMasterKeyTermKeysByTermApi = "getMasterKeyTermKeysByTerm"
export const checkMacMasterKeyTermKeysByTermApi = "getMacMasterKeyTermKeysByTerm"
export const getEncryptionKeysBySATermApi = "getEncryptionKeysBySATerm"
export const checkCryptogramOneApi = ""
export const commitFinalTerminalConfirmationApi = "validateAndEditTerminalKeys"
export const validateAndSaveTerminalKeysApi ="validateAndSaveTerminalKeys"
//mackeybinding
export const commitFinalMacTerminalConfirmationApi = "validateAndEditMacTerminalKeys"
export const validateAndSaveMacTerminalKeysApi ="validateAndSaveMacTerminalKeys"
//Cash Monitoring
export const CashMonitoringMgmtApi = "getCashMonitoringDisplay";
//C260Rollup Monitoring
export const C260RollupSummaryApi = "getC260RollUpSummaryDisplay";
export const downloadC260MonthlyRollUpApi= "downloadC260MonthlyRollUpSummaryReport";
//DailyAdjustment
export const DailyAdjustmentSummaryApi = "getDailyAdjustmentSummaryDisplay";
export const downloadDailyAdjustmentSummaryApi= "downloadDailyAdjustmentSummaryReport";

//transactionLookUp
export const  getTransactionLookupApi="getTransactionLookup";
export const getTerminalByUserIdApi= "getTerminalByUserId";
export const downloadTransactionLookupApi= "downloadTransactionLookup";